import { Button } from '@1trading/react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="grid h-full place-items-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <h1 className="text-4xl font-semibold">404</h1>
        <p className="text-muted-foreground">This page does not exist.</p>
        <Button asChild variant="outline">
          <Link to="/">Back to Home</Link>
        </Button>
      </div>
    </div>
  );
};
NotFoundPage.displayName = 'NotFoundPage';

export default NotFoundPage;
